import React from 'react';
import {
    Dialog,
    TextField,
    MenuItem,
    IconMenu,
    Subheader,
    FlatButton,
    CircularProgress,
    Card,
    CardText,
    CardHeader,
    Divider,
    Toolbar,
    ToolbarGroup,
    Paper,
    List,
    ListItem,
    SelectField,
} from 'material-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import IconCampaigns from 'material-ui/svg-icons/places/all-inclusive';
import config from 'cfg';
import req from 'superagent';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import auth from 'dash-front/auth';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconDownload from 'material-ui/svg-icons/file/file-download';
import IconLink from 'material-ui/svg-icons/content/link';
import IconEdit from 'material-ui/svg-icons/image/edit';
import IconStyle from 'material-ui/svg-icons/image/style';
import IconOpenInNew from 'material-ui/svg-icons/action/open-in-new';
import { browserHistory } from 'react-router';
import update from 'immutability-helper';
import { browserDownloadWidget2image, browserDownloadWidget2video } from '../../../../widgets/actions/widgets';
import cfg from 'cfg';
import pickers from '../pickers';
import { getProviders, addInputText } from 'dash-front/inputs/common';
import { safeParse } from 'dash-front/helpers';
import WDPContext from '../../../../widgets/components/core/WDPContext';
import EmojiPicker from 'dash-front/campaign/components/Form/pickers/EmojiPicker';
import { OddsPicker } from 'dash-front/odds';
import { setEventId } from 'dash-front/odds/actions';

const EnhancedOddsPicker = compose(
    connect(),
    lifecycle({
        componentDidMount() {
            if (this.props.eventId) {
                this.props.dispatch(setEventId(this.props.eventId));
            }
        },
        componentWillReceiveProps({ eventId }) {
            if (this.props.eventId !== eventId) {
                this.props.dispatch(setEventId(eventId));
            }
        },
    }),
)(OddsPicker);

const fixDialoguePos = () => {
    // window.dispatchEvent(new Event('resize'));
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, 500);
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, 1000);
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, 2000);
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, 3000);
};
const SMPostDialog = connect(state => ({
    defaultProvider: _.get(state, ['user', 'props', 'oddsProvider']),
    allowedProviders: _.get(state, ['user', 'props', 'allowedProviders']),
    bitlyAccessToken: _.get(state, ['user', 'props', 'bitlyAccessToken'], config.bitlyKey),
}))(
    class extends React.Component {
        static defaultProps = {
            showAllParams: false,
        };

        constructor(props, context) {
            super(props, context);

            const { defaultProvider, allowedProviders } = props;
            const providers = getProviders(safeParse(allowedProviders));
            const provider = defaultProvider && providers.some(p => p.id === defaultProvider) ? defaultProvider : null;

            this.templateObserver = this.context.templateObserver;
            this.state = {
                message: '',
                textGenerating: false,
                widget: props.previewWidget,
                socialMessage: '',
                fbPagesLoading: false,
                contentGenerating: false,

                fbIsPosting: false,

                showFBSourceSelect: false,
                showTwitterSelect: false,
                // PostingProcess component
                showProcess: false,
                // odds
                providers,
                provider,
            };
        }

        componentWillReceiveProps({ allowedProviders }) {
            if (this.props.allowedProviders !== allowedProviders) {
                const providers = getProviders(safeParse(allowedProviders));
                this.setState({ providers });
            }
        }

        componentDidMount = () => {
            //load user images from media gallery

            window.fbAsyncInit = () => {
                window.FB.init({
                    appId: config.fbWDP.appId,
                    cookie: true,
                    xfbml: true,
                    version: 'v2.10',
                });
                this.setState({ fbLoaded: true });
            };

            fixDialoguePos();
        };

        assignInputRef = el => {
            if (el) {
                if (el.input instanceof Node) {
                    this.inputRef = el.input;
                } else {
                    this.inputRef = el.input.refs.input;
                }
                this.addText = addInputText(this.inputRef, this.onMessageChange);
            }
        };

        static contextTypes = {
            user: PropTypes.object.isRequired,
            templateObserver: PropTypes.object.isRequired,
            campaigns: PropTypes.array.isRequired,
            widgets: PropTypes.array.isRequired,
        };

        handleDownload = () => {
            const { user, widgets } = this.context;
            const { widget, jsprops } = this.state;

            this.setState({ downloadProcess: true });

            var widgetCfg = _.find(widgets, w => String(w.id) === String(widget.name));

            if (widgetCfg.spec.video) {
                var videoUrl = config.WDPLinkr.widget.animated(user.client, user.username, 'default', widget.name, {
                    ...RCore.prepareWidgetPropsObj(jsprops),
                    // startAnimation: false,
                    js: true,
                    zoom: null,
                    load: null,
                });
                browserDownloadWidget2video(widgetCfg, videoUrl).then(r => {
                    this.setState({
                        downloadProcess: false,
                    });
                });
            } else {
                var smUrl = config.WDPLinkr.widget.sm(user.client, user.username, 'default', widget.name, {
                    ...RCore.prepareWidgetPropsObj(jsprops),
                    __mode: 'strict',
                });

                var htmlUrl = config.WDPLinkr.widget.iframe(
                    user.client,
                    user.username,
                    user.defaultTheme,
                    widget.name,
                    {
                        ...RCore.prepareWidgetPropsObj(jsprops),
                        __mode: 'strict',
                    },
                );

                var url = widgetCfg.spec.social ? smUrl : htmlUrl;

                browserDownloadWidget2image(widgetCfg, url).then(r => this.setState({ downloadProcess: false }));
            }
        };

        onClose = e => {
            this.setState(() => {
                if (this.props.onRequestClose) {
                    this.props.onRequestClose(e);
                }
            });
        };

        onMessageChange = (event, message) => {
            this.setState({ message: typeof event === 'string' ? event : message });
        };

        renderContent() {
            const { user, campaigns } = this.context;
            const { showAllParams } = this.props;
            const { downloadProcess, widget, fbLoaded, jsprops } = this.state;

            return (
                <div>
                    {widget && (
                        <FastWidgetEdit
                            widget={widget}
                            showAllParams={showAllParams}
                            onPropsChange={(key, val, props) => {
                                this.setState({ jsprops: props });
                                if (this.props.onPropsChange) this.props.onPropsChange(props);
                                fixDialoguePos();
                            }}
                        />
                    )}
                </div>
            );
        }

        handleSubmitPost = (c, params) => {
            const { widget } = this.state;
            const { user } = this.context;
            const url = cfg.campaign_manager.host + '/api/posts?access_token=' + auth.getAccessToken();

            const body = {
                campaignId: c._id,
                presentation: {
                    name: widget.name,
                    params: _.extend(
                        {
                            username: user.username,
                            client: user.client,
                            theme: 'default',
                        },
                        params,
                    ),
                    type: 'widget-social',
                },
                content: {
                    message: this.state.message,
                },
            };

            fetch(url, {
                method: 'post',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
                .then(res => res.json())
                .then(res => {
                    browserHistory.push({
                        pathname: `/campaigns/view/${c._id}`,
                    });
                });
        };

        getActions() {
            const { campaigns, user } = this.context;
            const { downloadProcess, widget, fbLoaded, jsprops = {} } = this.state;

            let url;

            if (widget.spec.video) {
                url = config.WDPLinkr.widget.animated(user.client, user.username, 'default', widget.name, {
                    ...jsprops,
                    zoom: null,
                    load: null,
                });
            } else {
                url = config.WDPLinkr.widget.sm(user.client, user.username, 'default', widget.name, {
                    ...jsprops,
                    __mode: 'strict',
                });
            }

            return [
                <FlatButton
                    key="Down"
                    label="Download"
                    disabled={downloadProcess}
                    onClick={() => this.handleDownload()}
                    icon={downloadProcess ? <CircularProgress size={24} /> : <IconDownload />}
                />,
                <IconMenu
                    key="cmp"
                    iconButtonElement={
                        <FlatButton
                            disabled={campaigns.length === 0}
                            label="Post to campaign"
                            icon={<IconCampaigns />}
                        />
                    }
                >
                    {campaigns.map(c => {
                        return (
                            <MenuItem
                                key={c.title}
                                desktop
                                primaryText={c.title}
                                onTouchTap={() => {
                                    this.handleSubmitPost(c, jsprops);
                                }}
                            />
                        );
                    })}
                </IconMenu>,
                <IconMenu
                    key="cmpa"
                    desktop
                    iconButtonElement={<FlatButton style={{ minWidth: 0 }} icon={<MoreVertIcon />} />}
                    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                >
                    <MenuItem disabled leftIcon={<IconLink />} primaryText="Get Links" />
                    <Divider />
                    <MenuItem
                        leftIcon={<IconEdit />}
                        primaryText="Full Edit"
                        onTouchTap={() => {
                            browserHistory.push({
                                pathname: `/sm/browser/post/${widget.name}/`,
                                query: jsprops,
                            });
                        }}
                    />
                    <MenuItem
                        leftIcon={<IconStyle />}
                        primaryText="Edit widget theme"
                        onTouchTap={() =>
                            browserHistory.push({
                                pathname: `/sm/templates/edit`,
                                query: { wid: widget.name, tid: jsprops.template },
                            })
                        }
                    />
                    <MenuItem
                        leftIcon={<IconOpenInNew />}
                        primaryText="Open in new window"
                        onTouchTap={() => {
                            window.open(url, '_blank');
                        }}
                    />
                </IconMenu>,
            ];
        }

        handleOddAdd = ({ message, url }) => {
            if (url) {
                this.setState({ textGenerating: true });
                const path = `${cfg.dash.api.host}/api/media/shorten-url`;
                req.get(path)
                    .query({ url, accessToken: this.props.bitlyAccessToken })
                    .then(res => {
                        this.setState({ textGenerating: false });
                        if (res.body.data && res.body.data.url) {
                            const { url } = res.body.data;
                            const hasNewLine = message && message.charAt(message.length - 1) === '\n';
                            let next = null;
                            if (message) {
                                next = hasNewLine ? message + url : message + '\n' + url;
                            } else {
                                next = url;
                            }
                            this.addText(this.state.message)(`${next}\n`);
                        }
                    })
                    .catch(e => {
                        this.setState({ textGenerating: false });
                    });
            } else if (message) {
                this.addText(this.state.message)(message);
            }
        };

        renderOddsPicker() {
            const { providers, jsprops = {} } = this.state;
            let { eventId } = jsprops;
            eventId = eventId || this.props.eventId;
            const shouldShow = providers && providers.length > 0;
            const showEventPicker = !eventId;
            return shouldShow ? (
                <EnhancedOddsPicker eventId={eventId} showEventPicker={showEventPicker} onAdd={this.handleOddAdd} />
            ) : null;
        }

        renderDialogue() {
            const { open, showAllParams } = this.props;
            return (
                <Dialog
                    open={open}
                    modal={false}
                    autoScrollBodyContent
                    onRequestClose={this.onClose}
                    repositionOnUpdate
                    contentStyle={{
                        width: 1180,
                        maxWidth: 'none',
                    }}
                    actions={this.getActions()}
                >
                    <div>{this.renderContent()}</div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <TextField
                                multiLine
                                floatingLabelText="Social message text"
                                floatingLabelFixed
                                hintText="For FB and Twitter"
                                disabled={this.state.textGenerating}
                                name="message"
                                style={{ width: 753 }}
                                value={this.state.message}
                                onChange={this.onMessageChange}
                                ref={this.assignInputRef}
                            />
                            {this.renderOddsPicker()}
                            <EmojiPicker
                                value={this.state.message}
                                disabled={this.state.textGenerating}
                                onChange={this.onMessageChange}
                                inputRef={this.inputRef}
                            />
                        </div>
                    </div>
                </Dialog>
            );
        }

        renderInline() {
            const { user, widgets } = this.context;
            const { widget } = this.state;
            var widgetCfg = widget && _.find(widgets, w => String(w.id) === String(this.state.widget.name));
            return (
                <div>
                    <Paper style={{ marginBottom: 16, marginLeft: -16, marginRight: -16, marginTop: -16 }} zDepth={0}>
                        <Toolbar>
                            <ToolbarGroup>{this.props.title || widgetCfg.name}</ToolbarGroup>
                        </Toolbar>
                    </Paper>
                    {this.renderContent()}

                    {widget && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <TextField
                                    multiLine
                                    floatingLabelText="Social message text"
                                    floatingLabelFixed
                                    hintText="For FB and Twitter"
                                    name="message"
                                    style={{ width: 753 }}
                                    value={this.state.message}
                                    onChange={this.onMessageChange}
                                    ref={this.assignInputRef}
                                />
                                {this.renderOddsPicker()}
                                <EmojiPicker
                                    value={this.state.message}
                                    onChange={this.onMessageChange}
                                    inputRef={this.inputRef}
                                />
                            </div>
                        </div>
                    )}

                    {widget && (
                        <Paper style={{ marginBottom: -16, marginLeft: -16, marginRight: -16 }} zDepth={0}>
                            <Toolbar>
                                <ToolbarGroup />
                                <ToolbarGroup>{widget && this.getActions()}</ToolbarGroup>
                            </Toolbar>
                        </Paper>
                    )}
                </div>
            );
        }

        render() {
            const { inline } = this.props;

            if (inline) {
                return this.renderInline();
            } else {
                return this.renderDialogue();
            }
        }
    },
);

function cancellable(func) {
    var cancelled = false;

    var cancellabled = function() {
        if (!cancelled) {
            func(...arguments);
        }
    };

    cancellabled.cancel = function() {
        cancelled = true;
        if (typeof func.onCancel === 'function') {
            func.onCancel();
        }
    };

    return cancellabled;
}

class FastWidgetEdit extends React.Component {
    static defaultProps = {
        showAllParams: false,
    };

    constructor(props, context) {
        super(props, context);
        this.templateObserver = this.context.templateObserver;
        const { user } = context;
        const { widget } = props;

        var clientPreferences = {
            lang: _.get(user, 'props.lang'),
            tz: _.get(user, 'props.timezone', 'CET'),
        };

        var widgetDefaults = _.chain(widget.spec.propTypes)
            .map(i => {
                return [i.key, i.defaultValue];
            })
            .fromPairs()
            .value();

        this.state = {
            widget: widget,
            jsprops: _.extend(
                {},
                _.pickBy(clientPreferences),
                _.pickBy(widgetDefaults),
                {
                    template: this.templateObserver.getTemplate(),
                },
                RCore.injectorParams2Obj(widget.props),
            ),
        };
        const widgetId = widget.id || widget.name;

        this.widgetRequestCallback = cancellable(() => {
            this.setState({
                [widgetId]: true,
            });
        });

        window.wdpload(widgetId, {}, {}, this.widgetRequestCallback);
    }

    componentDidMount = () => {
        if (this.props.onPropsChange) this.props.onPropsChange(null, null, this.state.jsprops);
    };

    componentWillReceiveProps = () => {};

    componentWillUnmount = () => {
        if (this.widgetRequestCallback) this.widgetRequestCallback.cancel();
    };

    static contextTypes = {
        user: PropTypes.object.isRequired,
        templateObserver: PropTypes.object.isRequired,
        campaigns: PropTypes.array.isRequired,
        widgets: PropTypes.array.isRequired,
    };

    changePropValue = (prop, val) => {
        let changedProp;
        if (typeof prop === 'object') {
            changedProp = prop;
        } else {
            changedProp = {};
            changedProp[prop] = val;
        }

        var upd = update(this.state, {
            jsprops: {
                $merge: changedProp,
            },
        });
        upd.jsprops = _.omit(upd.jsprops);
        this.setState(upd, () => {
            if (this.props.onPropsChange) this.props.onPropsChange(prop, val, this.state.jsprops);
        });
    };

    render = () => {
        const { user } = this.context;
        const { showAllParams, widget } = this.props;
        const { jsprops } = this.state;

        const widgetId = widget.id || widget.name;

        const CMP = _.get(window, `[rlz${widgetId}][${widgetId}]`);

        // var widgetCfg = _.find(widgets, w => String(w.id) === String(widgetId));

        //console.log('picker', widget.spec.demo);

        return (
            <div style={{ display: 'flex' }}>
                <div style={{ width: 300, minWidth: 300, marginRight: 16, flexGrow: 1 }}>
                    <WidgetParams
                        key="123"
                        widget={widget}
                        showAllParams={showAllParams}
                        jsprops={jsprops}
                        onPropChange={this.changePropValue}
                    />
                    <br />
                    <Card initiallyExpanded>
                        <CardHeader title="Demo examples" />

                        <List>
                            {widget &&
                                widget.spec.demo.map(demo => {
                                    return (
                                        <ListItem
                                            key={demo.title}
                                            primaryText={demo.title}
                                            onClick={e => {
                                                const props = _.clone(demo.props);

                                                Reflect.deleteProperty(props, 'template');

                                                browserHistory.push({
                                                    pathname: `/sm/browser/post/${widget.name}/`,
                                                    query: _.extend({}, jsprops, props),
                                                });

                                                this.setState({
                                                    jsprops: _.extend({}, jsprops, props),
                                                });
                                            }}
                                        />
                                    );
                                })}
                        </List>
                    </Card>
                </div>
                <div style={{ width: 800, minWidth: 800, minHeight: 600 }}>
                    {CMP && (
                        <Paper
                            zDepth={1}
                            style={{
                                position: 'sticky',
                                top: '75px',
                                // position: '-webkit-sticky'
                            }}
                        >
                            <WDPContext
                                client={user.client}
                                user={user.username}
                                token={user.accessToken}
                                lang={jsprops.lang}
                                tz={jsprops.tz}
                                key={widget.id + '_' + jsprops.template}
                                {...jsprops}
                                editMode
                            >
                                <CMP name={widgetId} {...jsprops} editMode />
                            </WDPContext>
                        </Paper>
                    )}
                    {/* {JSON.stringify(jsprops, null, 2)} */}
                </div>
            </div>
        );
    };
}

class WidgetParams extends React.PureComponent {
    shouldComponentUpdate = (nextProps, nextState) => {
        // if was changed any of required params....

        // let { widget } = this.props;
        // let newP = nextProps.jsprops;
        // let oldP = this.props.jsprops;
        // let requiredParamWasChanged = _.filter(
        //     widget.spec.propTypes,
        //     pp =>
        //         (pp.required && newP[pp.key] !== oldP[pp.key]) ||
        //         (pp.propsMap && _.find(_.values(pp.propsMap), pm => newP[pm] !== oldP[pm]))
        // );

        // if (requiredParamWasChanged.length) {
        //     return true;
        // }

        return true;
    };

    render = () => {
        const { widget, showAllParams, jsprops, onPropChange, backgroundOnly } = this.props;

        const pp = _.filter(widget.spec.propTypes, p => showAllParams || p.ui);
        let groups = _.groupBy(pp, i => {
            if (i.scope) return i.scope;
            // if (i.loader && i.required === false) return 'other';
            if (i.required) return 'required';
            if (i.ui) return 'ui';
            return 'other';
        });

        if (backgroundOnly) groups = _.pick(groups, 'images');

        return (
            <div>
                {Object.keys(groups).map(g => {
                    var title = g.charAt(0).toUpperCase() + g.substr(1);
                    return (
                        <Card key={g} zDepth={1}>
                            <CardHeader
                                title={`${title} scope`}
                                subtitle={groups[g].map(g => g.label).join(', ')}
                                style={{ background: '#f0f0f0' }}
                                subtitleStyle={{}}
                                actAsExpander
                                showExpandableButton
                            />
                            <CardText
                                expandable
                                style={{
                                    boxShadow: 'inset 0 0 3px #f0f0f0',
                                    marginBottom: -8,
                                    border: '1px solid #f0f0f0',
                                }}
                                className="pickers-wrapper"
                            >
                                {groups[g].map((propType, i) => {
                                    var Picker = pickers[propType.type];
                                    if (!Picker) return <div>{propType.type}</div>;
                                    return [
                                        <Picker
                                            key={propType.key}
                                            propKey={propType.key}
                                            {...propType}
                                            {...propType.props}
                                            {...jsprops}
                                            value={jsprops[propType.key]}
                                            onChange={onPropChange}
                                            error={false}
                                        />,
                                        i !== groups[g].length - 1 && (
                                            <Divider
                                                key={propType.key + 'd'}
                                                style={{ marginLeft: -16, marginRight: -16, marginTop: 16 }}
                                            />
                                        ),
                                    ];
                                })}
                            </CardText>
                        </Card>
                    );
                })}
            </div>
        );
    };
}

SMPostDialog.propTypes = {
    templateId: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};
export { WidgetParams };
export default SMPostDialog;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/SMPostDialog.js
 **/